import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageContainerProps {
  children: ReactNode;
  maxWidth?: string | number;
  className?: string;
}

export function PageContainer({ 
  children, 
  maxWidth = '1400px',
  className 
}: PageContainerProps) {
  return (
    <div className="w-full flex justify-center">
      <div 
        className={cn(
          'w-full px-4 sm:px-6 lg:px-8 py-6 lg:py-8',
          className
        )}
        style={{ maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth }}
      >
        {children}
      </div>
    </div>
  );
}

